export default __webpack_public_path__ + "static/media/logoMiView.543b8411.png";